(() => {
  'use strict';
  if (window.casamonteFooterControlsLoaded) return;
  window.casamonteFooterControlsLoaded = true;
  let privacyPromise;
  let mapTrigger;
  let cookieTrigger;
  const timeout = (promise, ms) => new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Timed out')), ms);
    Promise.resolve(promise).then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
  });
  function privacyAPI() {
    if (window.Shopify?.customerPrivacy?.currentVisitorConsent) return Promise.resolve(window.Shopify.customerPrivacy);
    if (privacyPromise) return privacyPromise;
    privacyPromise = timeout(new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) { reject(new Error('Shopify unavailable')); return; }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        if (error || !window.Shopify.customerPrivacy) reject(error || new Error('Privacy unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    }), 10000).catch(error => { privacyPromise = undefined; throw error; });
    return privacyPromise;
  }
  function currentChoices(api, form) {
    const consent = api.currentVisitorConsent();
    const allowed = { preferences: 'preferencesProcessingAllowed', analytics: 'analyticsProcessingAllowed', marketing: 'marketingAllowed' };
    for (const key of Object.keys(allowed)) form.elements[key].checked = consent[key] === 'yes' || (consent[key] !== 'no' && api[allowed[key]]());
  }
  async function saveChoices(form, choice) {
    if (form.getAttribute('aria-busy') === 'true') return;
    form.setAttribute('aria-busy', 'true');
    const error = form.querySelector('[data-consent-error]');
    error.hidden = true;
    const buttons = [...form.querySelectorAll('button')];
    buttons.forEach(button => { button.disabled = true; });
    try {
      const api = await privacyAPI();
      const consent = {};
      for (const key of ['preferences','analytics','marketing']) consent[key] = choice === 'accept' || (choice !== 'decline' && form.elements[key].checked);
      // Only a visitor's save/accept/decline action changes consent. Sale-of-data stays separate.
      await timeout(new Promise((resolve, reject) => api.setTrackingConsent(consent, data => data?.error ? reject(new Error(data.error)) : resolve())), 10000);
      const saved = api.currentVisitorConsent();
      if (Object.keys(consent).some(key => saved[key] !== (consent[key] ? 'yes' : 'no'))) throw new Error('Consent not confirmed');
      document.getElementById('casamonte-cookie-dialog').close();
      const status = document.getElementById('casamonte-privacy-status');
      status.textContent = status.dataset.saved; status.hidden = false;
    } catch (_) { error.hidden = false; }
    finally { form.removeAttribute('aria-busy'); buttons.forEach(button => { button.disabled = false; }); }
  }
  document.addEventListener('submit', event => {
    if (event.target.id !== 'casamonte-cookie-form') return;
    event.preventDefault(); saveChoices(event.target, 'save');
  });
  document.addEventListener('click', async event => {
    const choice = event.target.closest?.('[data-consent-choice]');
    if (choice) { saveChoices(choice.form, choice.dataset.consentChoice); return; }
    const link = event.target.closest?.('a');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.hasAttribute('data-casamonte-accessibility')) {
      if (typeof window.UserWay?.widgetOpen === 'function') {
        event.preventDefault();
        try { window.UserWay.widgetOpen(); } catch (_) { window.location.assign(link.href); }
      }
    }
    if (link.hasAttribute('data-casamonte-cookies')) {
      const dialog = document.getElementById('casamonte-cookie-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      try {
        const api = await privacyAPI();
        currentChoices(api, document.getElementById('casamonte-cookie-form'));
        dialog.querySelector('[data-consent-error]').hidden = true;
        cookieTrigger = link; dialog.showModal();
      } catch (_) { window.location.assign(link.href); }
      finally { link.removeAttribute('aria-busy'); }
    }
    if (link.hasAttribute('data-casamonte-maps') && window.matchMedia('(max-width: 767px), (pointer: coarse)').matches) {
      const dialog = document.getElementById('casamonte-map-dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault(); mapTrigger = link; dialog.showModal();
      }
    }
  });
  document.addEventListener('close', event => {
    const trigger = event.target.id === 'casamonte-map-dialog' ? mapTrigger : event.target.id === 'casamonte-cookie-dialog' ? cookieTrigger : null;
    if (trigger?.isConnected) trigger.focus();
  }, true);
})();
